import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { DANHGIA_DETAI_API, BaseGateway, BaseGatewayImage } from '../../../../utils/apiUrl';
import { trangThaiGuiKetQuaValue } from '../../../../utils/define';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import * as moment from 'moment';

const FieldDisplayFile = ({ label, value }) => {
    const getSafeUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
        const safePath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${safePath}`;
    };

    let files = [];
    if (value) {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
                files = parsed;
            } else {
                files = [{ filePath: value, name: value.split('/').pop() }];
            }
        } catch (e) {
            files = [{ filePath: value, name: value.split('/').pop() }];
        }
    }

    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div className="d-flex flex-wrap">
                {files.length > 0 ? (
                    files.map((file, idx) => {
                        const path = file.filePath || file;
                        let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                        return (
                            <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'} mb-1 mr-1`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                <i className="fas fa-paperclip mr-1"></i> {name}
                            </a>
                        );
                    })
                ) : (
                    <span className="text-muted small">Không có file</span>
                )}
            </div>
        </Form.Group>
    );
};

const DanhGiaDeTaiForm = ({ thayDoiDeTaiId, readOnly = false, isUserView = false, refetchParent = () => {} }) => {
    const [saving, setSaving] = useState(false);
    const [formData, setFormData] = useState({
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        fileQuyetDinh: '',
        bienBanchamNgay: '',
        diem: '',
        fileBienBan: '',
        soQuyetDinhDoi: '',
        ngayQuyetDinhDoi: '',
        fileQuyetDinhDoi: '',
        tenDeTaiMoi: '',
        trangThaiGuiKetQua: trangThaiGuiKetQuaValue.chuaGui
    });

    const { data: danhGiaRes, refetch: refetchDanhGia, isLoading } = useQuery(
        ['danhGiaThayDoiDeTai', thayDoiDeTaiId], 
        () => Get(`${DANHGIA_DETAI_API.GET_BY_THAYDOI_ID}/${thayDoiDeTaiId}`),
        { 
            enabled: !!thayDoiDeTaiId,
            refetchOnWindowFocus: false 
        }
    );

    const danhGiaData = danhGiaRes?.data || danhGiaRes || null;

    useEffect(() => {
        if (danhGiaData && danhGiaData.id) {
            setFormData({
                soQuyetDinh: danhGiaData.soQuyetDinh || '',
                ngayQuyetDinh: danhGiaData.ngayQuyetDinh ? moment(danhGiaData.ngayQuyetDinh).format('YYYY-MM-DD') : '',
                fileQuyetDinh: danhGiaData.fileQuyetDinh || '',
                bienBanchamNgay: danhGiaData.bienBanchamNgay ? moment(danhGiaData.bienBanchamNgay).format('YYYY-MM-DD') : '',
                diem: danhGiaData.diem !== null ? danhGiaData.diem : '',
                fileBienBan: danhGiaData.fileBienBan || '',
                soQuyetDinhDoi: danhGiaData.soQuyetDinhDoi || '',
                ngayQuyetDinhDoi: danhGiaData.ngayQuyetDinhDoi ? moment(danhGiaData.ngayQuyetDinhDoi).format('YYYY-MM-DD') : '',
                fileQuyetDinhDoi: danhGiaData.fileQuyetDinhDoi || '',
                tenDeTaiMoi: danhGiaData.tenDeTaiMoi || '',
                trangThaiGuiKetQua: danhGiaData.trangThaiGuiKetQua !== undefined ? danhGiaData.trangThaiGuiKetQua : trangThaiGuiKetQuaValue.chuaGui
            });
        }
    }, [danhGiaData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };



const handleSave = async (isSend = false) => {
        setSaving(true);
        try {
            const dataToSave = {
                thayDoiDeTaiId: thayDoiDeTaiId,
                soQuyetDinh: formData.soQuyetDinh,
                ngayQuyetDinh: formData.ngayQuyetDinh || null,
                fileQuyetDinh: formData.fileQuyetDinh,
                bienBanchamNgay: formData.bienBanchamNgay || null,
                diem: formData.diem !== '' ? parseFloat(formData.diem) : null,
                fileBienBan: formData.fileBienBan,
                soQuyetDinhDoi: formData.soQuyetDinhDoi,
                ngayQuyetDinhDoi: formData.ngayQuyetDinhDoi || null,
                fileQuyetDinhDoi: formData.fileQuyetDinhDoi,
                tenDeTaiMoi: formData.tenDeTaiMoi,
                trangThaiGuiKetQua: isSend ? trangThaiGuiKetQuaValue.daGui : formData.trangThaiGuiKetQua
            };
            
            if (danhGiaData && danhGiaData.id) {
                await Put(DANHGIA_DETAI_API.UPDATE_ITEM, danhGiaData.id, dataToSave);
            } else {
                await Post(DANHGIA_DETAI_API.CREATE, null, dataToSave);
            }

            toast.success(isSend ? 'Gửi kết quả thành công!' : 'Lưu thông tin thành công!');
            await refetchDanhGia();
            refetchParent();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    return (
        <div className="bg-white p-3 rounded border">
            <h5 className="font-weight-bold text-primary mb-4 border-bottom pb-2">
                <i className="fas fa-clipboard-check mr-2"></i>Đánh giá thay đổi đề tài
            </h5>
            
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">1. Thành lập tiểu ban đánh giá đề cương</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="font-weight-bold">Số quyết định</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="soQuyetDinh" 
                                    value={formData.soQuyetDinh} 
                                    onChange={handleChange} 
                                    disabled={readOnly}
                                    className={readOnly ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="font-weight-bold">Ngày quyết định</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="ngayQuyetDinh" 
                                    value={formData.ngayQuyetDinh} 
                                    onChange={handleChange} 
                                    disabled={readOnly}
                                    className={readOnly ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            {readOnly ? (
                                <FieldDisplayFile label="File quyết định" value={formData.fileQuyetDinh} />
                            ) : (
                                <Form.Group>
                                    <DocumentInput
                                        labelTitle="File quyết định"
                                        value={formData.fileQuyetDinh}
                                        onChangeProp={(url) => setFormData({ ...formData, fileQuyetDinh: url })}
                                        readOnly={readOnly}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {!isUserView && (
                <Card className="mb-3 border-success shadow-sm">
                    <Card.Header className="bg-success text-white font-weight-bold">2. Chấm đề cương</Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Biên bản chấm ngày</Form.Label>
                                    <Form.Control 
                                        type="date" 
                                        name="bienBanchamNgay" 
                                        value={formData.bienBanchamNgay} 
                                        onChange={handleChange} 
                                        disabled={readOnly}
                                        className={readOnly ? "bg-white" : ""}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Điểm</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        step="0.1"
                                        name="diem" 
                                        value={formData.diem} 
                                        onChange={handleChange} 
                                        disabled={readOnly}
                                        className={readOnly ? "bg-white" : ""}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                {readOnly ? (
                                    <FieldDisplayFile label="File biên bản chấm đề cương" value={formData.fileBienBan} />
                                ) : (
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle="File biên bản chấm đề cương"
                                            value={formData.fileBienBan}
                                            onChangeProp={(url) => setFormData({ ...formData, fileBienBan: url })}
                                            readOnly={readOnly}
                                        />
                                    </Form.Group>
                                )}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            )}

            <Card className="mb-3 border-warning shadow-sm">
                <Card.Header className="bg-warning text-white font-weight-bold">{!isUserView ? '3' : '2'}. Ban hành quyết định đổi đề tài</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label className="font-weight-bold">Tên đề tài mới</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="tenDeTaiMoi" 
                                    value={formData.tenDeTaiMoi} 
                                    onChange={handleChange} 
                                    disabled={readOnly}
                                    placeholder="Nhập tên đề tài mới"
                                    className={readOnly ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="font-weight-bold">Số quyết định đổi đề tài</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="soQuyetDinhDoi" 
                                    value={formData.soQuyetDinhDoi} 
                                    onChange={handleChange} 
                                    disabled={readOnly}
                                    className={readOnly ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="font-weight-bold">Ngày quyết định đổi</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="ngayQuyetDinhDoi" 
                                    value={formData.ngayQuyetDinhDoi} 
                                    onChange={handleChange} 
                                    disabled={readOnly}
                                    className={readOnly ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            {readOnly ? (
                                <FieldDisplayFile label="File quyết định đổi đề tài" value={formData.fileQuyetDinhDoi} />
                            ) : (
                                <Form.Group>
                                    <DocumentInput
                                        labelTitle="File quyết định đổi đề tài"
                                        value={formData.fileQuyetDinhDoi}
                                        onChangeProp={(url) => setFormData({ ...formData, fileQuyetDinhDoi: url })}
                                        readOnly={readOnly}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave(false)} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                    <Button variant="primary" className="ml-2" onClick={() => handleSave(true)} disabled={saving || formData.trangThaiGuiKetQua === trangThaiGuiKetQuaValue.daGui}>
                        {saving ? <><Spinner size="sm" animation="border" className="mr-2" /> Đang gửi...</> : <><i className="fas fa-paper-plane mr-2"></i> {formData.trangThaiGuiKetQua === trangThaiGuiKetQuaValue.daGui ? 'Đã gửi kết quả' : 'Gửi kết quả'}</>}
                    </Button>
                </div>
            )}
        </div>
    );
}

export default DanhGiaDeTaiForm;
